const convertNumbDote = (x?: number): string => {
  if (!x) {
    return '0'
  }
  return x.toLocaleString('pt-BR')
}
export default convertNumbDote
